import React, { useState, useContext, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../.././../utils/secure-route/AuthContext";
import SettingTable from "../ManageSettings/SettingTable";
import "./GeneralLedger.css";
import useSwal from "../../../common/ReusableComponent/useSwal";
import bankdeposite from '../../../../assets/Image/Bank Deposite .png'
import CloseIcon from "../../../../assets/Image/close.png";
import { useToastHandler } from "../../../common/ToastHandler";
import CustomDateInput from "../../../../context/CustomDateInput";
import useFormattingUtils from "../../../../context/useFormattingUtils";
import ReusableTable from "../../../common/ReusableComponent/reusableTable/ReusableTable";
import useMyPermissions from "../../../../utils/permissions/useMyPermissions";
import Can from "../../../../utils/permissions/Can";

export default function GeneralLedgerBank() {
  const { user } = useContext(AuthContext);
  const { Get, Post, Delete, Put, getAPI, GetPaginatedData } = useApi();
  const { can } = useMyPermissions();
  const storeid = user.store;
  const [banks, setBanks] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { handleToast } = useToastHandler();
  const { confirmDelete } = useSwal();
  const [bankDeposit, setBankDeposit] = useState([]);
  const [loading, setLoading] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const { formatDate } = useFormattingUtils();

  const [formData, setFormData] = useState({
    store: storeid,
    sr_no: "",
    date: today,
    transaction_type: "Bank Deposit",
    bank: "",
    pay_method_status: "pay_now",
    pay_method: "cash",
    amount: "",
    cash_amount: "",
    cheque_amount: "",
    total_amount: "",
    note: "",
    bank_deposite_type: null,
    owner: null,
  });

  useEffect(() => {
    fetchBanks();
    fetchBankData();
  }, []);

  const convertDateToApiFormat = (dateString) => {
    if (!dateString) return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      const [month, day, year] = dateString.split('-');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return date.toISOString().split('T')[0];
    }

    return null;
  };

  const convertToInputFormat = (dateString) => {
    if (!dateString) return today;

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      const [month, day, year] = dateString.split('-');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return date.toISOString().split('T')[0];
    }

    return today;
  };

  const fetchBankData = async ({ page = 1, searchTerm = "", sort = "", } = {}) => {
    try {
      setLoading(true);

      const response = await GetPaginatedData("transactionData", {
        page,
        search: searchTerm,
        queryParams: {
          ...(sort && { sort }),
          transaction_type: "Bank Deposit"
        }
      });

      const results = response?.data || [];
      const count = response?.totalCount || 0;
      const totalPages = Math.ceil(count / 10);

      const formatted = results.map((item) => ({
        ...item,
        date: item.date ? formatDate(item.date) : "N/A",
      }));

      setBankDeposit(formatted);
      console.log(formatted)
      return { data: formatted, totalPages };
    } catch (error) {
      console.error("Error fetching bank data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBanks = async () => {
    try {
      const response = await Get("bank");
      const bankList = response?.results || [];
      setBanks(bankList);
    } catch (error) {
      console.error("Error fetching banks:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch banks.",
      });
    }
  };

  const handleDateChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      date: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleTotalAmountChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const newFormData = { ...prevData, [name]: value };

      if (name === "cash_amount" || name === "cheque_amount") {
        const cashAmount = parseFloat(newFormData.cash_amount) || 0;
        const chequeAmount = parseFloat(newFormData.cheque_amount) || 0;
        newFormData.total_amount = (cashAmount + chequeAmount).toString();
      }

      return newFormData;
    });
  };

  const toggleModal = () => {
    if (showModal) {
      resetFormData();
      setIsEditing(false);
      setCurrentRecord(null);
    }
    setShowModal(!showModal);

    if (!showModal) {
      setTimeout(() => {
        document.activeElement.blur();
      }, 0);
    }
  };

  const handleBankDeposit = async (event) => {
    event.preventDefault();
    const { sr_no, ...formDataWithoutSrNo } = formData;

    if (!formData.cash_amount && !formData.cheque_amount) {
      handleToast({
        type: "ERROR",
        message: "Please Enter Cash Amount or Cheque Amount"
      });
      return;
    }

    if (formData.cash_amount && parseFloat(formData.cash_amount) <= 0) {
      handleToast({
        type: "ERROR",
        message: "Cash Amount must be greater than 0."
      });
      return;
    }

    if (formData.cheque_amount && parseFloat(formData.cheque_amount) <= 0) {
      handleToast({
        type: "ERROR",
        message: "Cheque Amount must be greater than 0"
      });
      return;
    }

    if (!formData.bank_deposite_type) {
      handleToast({
        type: "ERROR",
        message: "Please select a valid Deposit type."
      });
      return;
    }

    try {
      const updatedFormData = {
        ...formDataWithoutSrNo,
        store: storeid,
        pay_method_status: null,
        pay_method: null,
        date: convertDateToApiFormat(formDataWithoutSrNo.date)
      };

      if (!updatedFormData.date) {
        handleToast({
          type: "ERROR",
          message: "Invalid date format. Please check the date."
        });
        return;
      }

      if (isEditing) {
        const response = await Put("transactionData", currentRecord.id, updatedFormData);

        if (response && (response.status === 200 || response.status === 204)) {
          handleToast({
            type: "SUCCESS",
            message: "Bank Deposit updated successfully!"
          });
          resetFormData();
          setIsEditing(false);
          setShowModal(false);
          setRefreshTrigger(prev => prev + 1);
        }
      } else {
        const response = await Post("transactionData", updatedFormData);

        if (response && (response.status === 200 || response.status === 201)) {
          handleToast({
            type: "SUCCESS",
            message: "Bank Deposit added successfully!"
          });
          resetFormData();
          setShowModal(false);
          setRefreshTrigger(prev => prev + 1);
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      handleToast({
        type: "ERROR",
        message: "Submission failed: " + error.message,
      });
    }
  };

  const handleEditBankDeposit = (recordOrId) => {
    console.log("Editing Record:", recordOrId);

    let record;

    if (typeof recordOrId === 'string') {

      record = bankDeposit?.find(item => item.id === recordOrId);
      if (!record) {
        console.error("Record not found for ID:", recordOrId);
        handleToast({
          type: "ERROR",
          message: "Error: Record not found.",
        });
        return;
      }
    } else if (recordOrId && typeof recordOrId === 'object' && recordOrId.id) {

      record = recordOrId;
    } else {
      console.error("Invalid record: Missing ID", recordOrId);
      handleToast({
        type: "ERROR",
        message: "Error: Cannot edit record, missing ID.",
      });
      return;
    }

    setIsEditing(true);
    setCurrentRecord(record);

    setFormData({
      store: storeid,
      sr_no: "",
      date: convertToInputFormat(record.date),
      transaction_type: "Bank Deposit",
      bank: record.bank || "",
      pay_method_status: "pay_now",
      pay_method: "cash",
      amount: record.amount || "",
      cash_amount: record.cash_amount || "",
      cheque_amount: record.cheque_amount || "",
      total_amount: record.total_amount || "",
      note: record.note || "",
      bank_deposite_type: record.bank_deposite_type || null,
      owner: record.owner || null,
    });

    setShowModal(true);
  };

  const handleDeleteBankDeposit = async (id) => {
    const result = await confirmDelete();
    if (!result.isConfirmed) return;

    try {
      await Delete("transactionData", id);

      setBankDeposit((prevBankDeposit) =>
        prevBankDeposit.filter((deposit) => deposit.id !== id)
      );

      handleToast({
        type: "SUCCESS",
        message: "Bank Deposit deleted successfully"
      });

      setRefreshTrigger(prev => prev + 1);
    } catch (error) {
      console.error("Error deleting Bank Deposit:", error);
      handleToast({
        type: "ERROR",
        message: "Error deleting Bank Deposit"
      });
    }
  };

  const resetFormData = () => {
    setFormData({
      store: storeid,
      sr_no: "",
      date: today,
      transaction_type: "Bank Deposit",
      bank: "",
      pay_method_status: "pay_now",
      pay_method: "cash",
      amount: "",
      cash_amount: "",
      cheque_amount: "",
      total_amount: "",
      note: "",
      bank_deposite_type: null,
      owner: null,
    });
    setIsEditing(false);
    setCurrentRecord(null);
  };

  const openAddModal = async () => {
    resetFormData();

    if (!showModal) {
      try {
        await fetchBanks();
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    }

    setShowModal(true);
  };

  const columns = [
    { header: "Sr", field: "sr_no" },
    { header: "Date", field: "date" },
    { header: "Bank", field: "bank_name" },
    { header: "Note", field: "note" },
    { header: "Type", field: "bank_deposite_type" },
    { header: "Cash Amount", field: "cash_amount" },
    { header: "Cheque Amount", field: "cheque_amount" },
    { header: "Total Amount", field: "total_amount" },
  ];

  return (
    <>
      <ToastContainer />
      <div className="">
        <div className="responsive-box">
          <div className="header-row mb-4">
            <div className="setting-title">Bank Deposit</div>
            <Can module="generalLedgerService" action="add">
            <button
              className="btn cus d-flex align-items-center"
              onClick={openAddModal}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#FFAF32",
                boxShadow: "none",
                outline: "none",
                width: "auto",
                height: "42px",
                padding: "8px 12px",
                fontSize: "14px",
                border: "none",
                borderRadius: "10px",
                color: "#000",
                cursor: "pointer",
                fontWeight: 'bold',
                gap: "8px",
              }}
            >
              Add Bank Deposit
              <img
                src={bankdeposite}
                alt="Bank Deposite Icon"
                style={{ width: "20px", height: "20px", marginLeft: "18px" }}
              />
            </button>
            </Can>
          </div>

          {showModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1000,
              }}
              onClick={toggleModal}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: "700px",
                  backgroundColor: "white",
                  margin: "100px auto",
                  borderRadius: "20px",
                  position: "relative",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div
                  className="modal-header"
                  style={{
                    borderBottom: "none",
                    paddingBottom: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <h5
                    className="modal-title"
                    style={{ fontWeight: "bold", marginLeft: "27px" }}
                  >
                    {isEditing ? "Edit Bank Deposit" : "Add Bank Deposit"}
                  </h5>
                  <img
                    src={CloseIcon}
                    alt="Close"
                    width="34"
                    height="34"
                    onClick={toggleModal}
                  />
                </div>
                <div className="modal-body">
                  <form onSubmit={handleBankDeposit}>
                    <div
                      className="form-row form-group col-md-12 d-flex align-items-center justify-content-around"
                    >
                      <CustomDateInput
                        value={formData.date || today}
                        onChange={handleDateChange}
                        required
                        readOnly
                        inputStyle={{
                          backgroundColor: "#ffffff",
                          height: "52px",
                          width: "268px",
                          marginLeft: '35px',
                          marginTop: '20px'
                        }}
                      />

                      <select
                        style={{
                          backgroundColor: "#ffffff",
                          height: "52px",
                          width: "268px",
                          marginRight: '28px'
                        }}
                        className="input-select"
                        id="bank_deposite_type"
                        name="bank_deposite_type"
                        value={formData.bank_deposite_type || ""}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Cash Type</option>
                        <option value="Business cash">Business Cash</option>
                        <option value="Gas cash">Gas Cash</option>
                        <option value="Lottery cash">Lottery Cash</option>
                      </select>
                    </div>

                    <div className="d-flex mb-3 mt-2 ">
                      <div className="col-md-5">
                        <select
                          style={{
                            backgroundColor: "#ffffff",
                            height: "52px",
                            marginLeft: "35px",
                            width: "265px"
                          }}
                          className="input-select"
                          name="bank"
                          value={formData.bank || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select a bank</option>
                          {banks && banks.map((bank) => (
                            <option key={bank.id} value={bank.id}>
                              {bank.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-row d-flex flex-wrap col-md-12 justify-content-around">
                      <div className="containercolor col-md-5">
                        <div
                          className="input-group p-2 mt-2"
                          style={{
                            backgroundColor: "#ffffff",
                            width: "281px",
                            height: "62px",
                          }}
                        >
                          <input
                            type="number"
                            className="form-control-borderless"
                            aria-label="Username"
                            aria-describedby="addon-wrapping"
                            placeholder="Cash Amount"
                            name="cash_amount"
                            value={formData.cash_amount || ""}
                            onChange={handleTotalAmountChange}
                            style={{ height: "52px" }}
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/[^0-9.]/g, '')
                                .replace(/^(\d*\.?\d{0,2}).*/g, '$1')
                                .slice(0, 12);
                            }}
                          />
                        </div>
                      </div>

                      <div className="containercolor col-md-5">
                        <div
                          className="input-group p-2 mt-2"
                          style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            height: "62px",
                          }}
                        >
                          <input
                            type="text"
                            className="form-control-borderless"
                            aria-label="Username"
                            aria-describedby="addon-wrapping"
                            placeholder="Cheque Amount"
                            name="cheque_amount"
                            value={formData.cheque_amount || ""}
                            onChange={handleTotalAmountChange}
                            style={{ height: "52px" }}
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/[^0-9.]/g, '')
                                .replace(/^(\d*\.?\d{0,2}).*/g, '$1')
                                .slice(0, 12);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="form-row d-flex mt-3 justify-content-between"
                      style={{ padding: "0 35px" }}
                    >
                      <div className="form-group" style={{ width: "48%", marginTop: '25px' }}>
                        <input
                          readOnly
                          type="text"
                          name="total_amount"
                          className="form-control-borderless"
                          value={formData.total_amount || ""}
                          placeholder="Total Amount"
                          style={{ height: "52px" }}
                        />
                      </div>
                      <div className="form-group" style={{ width: "48%" }}>
                        <label htmlFor="note">Note</label>
                        <textarea
                          id="note"
                          name="note"
                          className="form-control"
                          placeholder="Enter any notes about the deposit"
                          rows="3"
                          value={formData.note || ""}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#ffffff",
                            resize: "none",
                            borderRadius: "10px",
                            padding: "10px",
                            fontSize: "14px",
                            width: "100%",
                            minHeight: "62px"
                          }}
                        />
                      </div>
                    </div>

                    <div className="modal-footer" style={{ border: "none" }}>
                      <button
                        type="button"
                        className="btn btn-secondary-outline"
                        onClick={toggleModal}
                        style={{
                          border: " 1px solid #282e26", borderRadius: '50px', width: "181px",
                          height: "45px", fontWeight: "bold"
                        }}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn"
                        style={{
                          color: "white", backgroundColor: '#282e26', borderRadius: '50px', width: "181px",
                          height: "45px", fontWeight: "bold"
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          <ReusableTable
            fetchData={fetchBankData}
            columns={columns}
            showFooter={true}
            showAction={true}
            showExport={true}
            showFilter={false}
            enablePagination={true}
            key={refreshTrigger}
            itemsPerPage={10}
            onEdit={can("generalLedgerService", "change") ? handleEditBankDeposit : undefined}
            onDelete={can("generalLedgerService", "delete") ? handleDeleteBankDeposit : undefined}
          />
        </div>
      </div>
    </>
  );
}
